import { useCallback, useEffect, useState } from 'react';
// import EquipmentListTable from './EquipmentListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import EquipmentApi from '../../Api/EquipmentApi';
import { Equipment } from '../../Models/Equipment';
import EquipmentListTable from './EquipmentListTable';
import {
  EquipmentTypeEnums,
  EquipmentTypeStringEnums,
} from '../../Models/EquipmentTypeEnums';

export default function EquipmentList({
  manufacturerId,
  equipmentType,
}: {
  manufacturerId: number;
  equipmentType: EquipmentTypeEnums;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [equipmentListData, setEquipmentListData] = useState<Equipment[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getEquipments = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return EquipmentApi.getEquipmentList(manufacturerId, equipmentType)
          .then((res) => {
            setEquipmentListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel, equipmentType]);

  useEffect(() => {
    getEquipments();
  }, [getEquipments]);

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>{EquipmentTypeStringEnums[equipmentType]}</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div
            id='equipment-scroll-container'
            className='w-full p-4 h-[calc(100vh-420px)] md:h-[calc(100vh-390px)] lg:h-[calc(100vh-250px)] overflow-y-auto'
          >
            <EquipmentListTable
              data={equipmentListData}
              manufacturerId={manufacturerId}
              equipmentType={equipmentType}
            />
          </div>
        </div>
      </div>
    </>
  );
}
